module.exports = __webpack_public_path__ + "img/center-line.647616cf.svg";